import { Route, Routes } from 'react-router-dom';
import './Styles/App.css';
import Home from './Pages/Home';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer';
import Profile from './Pages/Profile';
import Products from './Pages/Products';
import Product from './Pages/Product';
import Login from './Pages/Login';
import AboutUs from './Pages/AboutUs';
import Services from './Pages/Services';
import LargeModal from './Components/LargeModal';

function App() {
  
  return (
    <div className="App">
      <Navbar/>
      <Routes>
        <Route path="/">
          <Route index element={<Home/>} />
          <Route path='profile' element={<Profile/>}/>
          <Route path='products/:category' element={<Products/>}/>
          <Route path='products/' element={<Products/>}/>
          <Route path='profile' element={<Profile/>}/>
          <Route path='products/product/:id' element={<Product/>}/>
          <Route path='product/:id' element={<Product/>}/>
          <Route path='services/:id' element={<Services/>}/>
          <Route path='custom/login' element={<Login/>}/>
          <Route path='aboutus' element={<AboutUs/>}/>
          <Route path='large' element={<LargeModal/>}/>
        </Route>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
